import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, Box } from "@mui/material";
import { useOrganizations, useSelectedOrganization } from "hooks";
import { Organization } from "model/organizationModel";

type NotificationsOrganizationsListProps = {
  value: number | null;
  onChange: (id: number) => void;
};

const NotificationsOrganizationsList: React.FC<NotificationsOrganizationsListProps> = ({
  value,
  onChange,
}) => {
  const [organizations] = useOrganizations();
  const selectedOrganization = useSelectedOrganization();

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id && value === null) {
      onChange(selectedOrganization.id);
    }
  }, [selectedOrganization, value, onChange]);

  const handleChange = (event: { target: { value: unknown } }) => {
    onChange(event.target.value as number);
  };

  return (
    <Box>
      <FormControl size="small" fullWidth>
        <Select
          value={value ?? ""}
          onChange={handleChange}
          displayEmpty
        >
          {organizations.map((org: Organization) => (
            <MenuItem key={org.id} value={org.id}>
              {org.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default NotificationsOrganizationsList;
